import './select-option.styles.scss';

export default angular.module('directives.abSelectOption', [])
  .directive('abSelectOption', () => {
    'ngInject';

    return {
      restrict: 'E',
      replace: true,
      templateUrl: require('./select-option.template.html'),
    };
  })
  .name;
